import { useEffect, useState } from 'react';
import { createTheme } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: '#eb3d26',
    },
  },
});

export const DateElement = (props) => {
  const { schema, selectedDate, handleDateChange } = props;
  const [localDate, setLocalDate] = useState(selectedDate);
  const { properties } = schema;

  useEffect(() => {
    setLocalDate(selectedDate);
  }, [selectedDate]);

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <DatePicker
        {...properties}
        value={localDate}
        onChange={(date) => {
          setLocalDate(date);
          handleDateChange(date);
        }}
        animateYearScrolling
        format="DD/MM/YYYY"
        className="date-picker-filter"
        clearable
      />
    </ThemeProvider>
  );
};
